module.exports = __webpack_public_path__ + "img/slide11.a4d79d85.png";